import { render, staticRenderFns } from "./ProductListWrapper.vue?vue&type=template&id=3b17e94a&scoped=true&"
import script from "./ProductListWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProductListWrapper.vue?vue&type=style&index=0&id=3b17e94a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b17e94a",
  null
  
)

export default component.exports